/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom'

import { Button, Input, Form, Image, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useForm } from 'antd/lib/form/Form';
import { register } from '../redux/AuthCRUD';

const initialValues = {
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
}

export function Registration() {
  const intl = useIntl();

  const [form] = useForm();

  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const history = useHistory();

  const onFinishRegister = async () => {
    setLoading(true); 
    try {
      const dataForm = form.getFieldsValue();
      const resData: any = await register(dataForm);
      if (resData?.data?.success) {
        messageApi.success(resData?.data?.message, 3, () => {
          history.push(`/auth/login`);
        });
      }
      if (resData?.data?.error) {
        messageApi.error(resData?.data?.error, 4, () => {
          console.log('---- có lỗi đăng ký -----')
        });
      }
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      messageApi.error(err?.message);
      console.log(err);
    }
  }

  return (
    <>
      {contextHolder}
      <Form form={form} layout="vertical" preserve={false} onFinish={onFinishRegister}>
        <div className="auth-wrapper">
          <div className="auth-content">
            <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div>
            <div className="card">
              <div className="card-body">
                <div className="mb-4">
                  <i className="feather icon-unlock auth-icon" />
                </div>
                <h3 className="mb-4">Tạo tài khoản mới</h3>
                <p className='text-black-50'>
                  {intl.formatMessage({ id: 'AUTH.REGISTER.DESC' })}
                </p>

                <Form.Item
                  hasFeedback
                  name="full_name"
                  rules={[
                    { required: true, message: 'Trường không để trống!', whitespace: true },
                    {
                      min: 3,
                      message: 'Họ tên ít nhất 3 kí tự'
                    }
                  ]}
                >
                  <Input
                    placeholder={"Họ và tên"}
                    prefix={<UserOutlined rev={undefined} />}
                    type='text'
                    name='full_name'
                    autoComplete='off'
                  />
                </Form.Item>

                <Form.Item
                  hasFeedback
                  name="username"
                  rules={[
                    {
                        required: true,
                        message: 'Trường không được trống',
                        whitespace: false
                    },
                    {
                        required: true,
                        type: "email",
                        message: "Email không đúng định dạng",
                    }
                  ]}
                >
                  <Input
                    placeholder='youremail@gmail.com'
                    prefix={<MailOutlined rev={undefined} />}
                    type='email'
                    name='email'
                    autoComplete='off'
                  />
                </Form.Item>
                <Form.Item
                  hasFeedback
                  name="password"
                  rules={[
                    {
                        required: true,
                        message: 'Trường không được trống',
                        whitespace: false
                    },
                    {
                        min: 8,
                        message: 'Mật khẩu ít nhất 8 kí tự'
                    }
                ]}
                >
                  <Input.Password
                    placeholder='Nhập vào mật khẩu'
                    autoComplete='off'
                    prefix={<LockOutlined rev={undefined} />}
                  />
                </Form.Item>
                <p className='text-muted'>Sử dụng 8 ký tự trở lên kết hợp chữ cái, số và ký hiệu.</p>

                <Form.Item
                  hasFeedback
                  name="password_confirmation"
                  dependencies={['password']}
                  rules={[
                    {
                      required: true,
                      message: 'Trường không được trống!',
                    },
                    () => ({
                      validator(_, value) {
                        if (!value || form.getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Mật khẩu mới bạn nhập không khớp!'));
                      },
                    })
                  ]}
                >
                  <Input.Password
                    placeholder="Xác nhận mật khẩu"
                    autoComplete='off'
                    prefix={<LockOutlined rev={undefined} />}
                  />
                </Form.Item>
                <Button
                  size='large'
                  style={{ width: '100%' }}
                  type='primary'
                  loading={loading}
                  htmlType='submit'
                >
                  {intl.formatMessage({ id: 'AUTH.GENERAL.SIGNUP_BUTTON' })}
                </Button>
                <Button
                  size='large'
                  style={{ width: '100%' }}
                  type='text'
                  onClick={() => history.push(`/auth/login`)}
                >
                  Đăng nhập
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  )
}
